import React, { useMemo, useState } from "react";
import { Formik, ErrorMessage, Form } from "formik";
import * as Yup from "yup";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import toastNotify from "../../utils/ToastNotify";
import TextField from "../../componants/textField/TextField";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { BiEnvelope, BiLeftArrowAlt, BiLoader, BiPhone, BiRefresh, BiSolidBank, BiUser } from "react-icons/bi";
import { Button, Card, Col, Row } from "react-bootstrap";
import { getCaptchaCode } from "../../apiService/ApiServices";

const InquiryForm = () => {

  const navigate = useNavigate();
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [captchaDtl, setCaptchaDtl] = useState(null);
  const [isCaptchaLoader, setIsCaptchaLoader] = useState(false);

  const getRegularCaptcha = async () => {
    setIsCaptchaLoader(true);
    const data = await getCaptchaCode()
    setCaptchaDtl(data);
    setIsCaptchaLoader(false);
  }

  useMemo(() => {
    getRegularCaptcha();
  }, []);

  const validationSchema = Yup.object().shape({
    personName: Yup.string().required("Full name is required"),
    mobileNo: Yup.string()
      .required("Mobile number is required")
      .matches(/^\d{10}$/, "Mobile number must be exactly 10 digits"),
    email: Yup.string().matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      "Invalid email format"
    ),
  });

  function handleSubmit(values, { resetForm }) {
    setIsLoading(true);
    setTimeout(() => {
      toastNotify("Form submitted successfully!", "success");
      resetForm();
      setIsLoading(false);
      navigate("/", { state: values });
    }, 1000);
  }


  // async function handleInquiry() {
  //   try {
  //     setIsLoading(true);
  //     const payload = {
  //       MOBILE_NO: state.MOBILE_NO,
  //       EMAIL: state.EMAIL,
  //       OTP_CD: OTPValues,
  //       DOMAIN_NM: window.location.hostname,
  //       IP_ADDRESS: identifyData.ip
  //     };
  //     const checksum = computeCrc(JSON.stringify(payload));

  //     await axios({
  //       method: "POST",
  //       url: urls.setProductInquiry,
  //       data: payload,
  //       headers: {
  //         "Content-Type": "application/json",
  //         Checksum: checksum,
  //         Authorization: AuthKey,
  //       },

  //     }).then((result) => {
  //       if (result.data.STATUS === "0") {
  //         const response = result.data.RESPONSE[0];
  //         setUserData(response);
  //         setLocalAccessToken(response.ACCESS_TOKEN);
  //         setLocalRefreshToken(response.REFRESH_TOKEN);
  //         navigate("/dashboard");
  //       } else {
  //         toastNotify(result.data.MESSAGE, "error");
  //         setOtpValues(["", "", "", "", "", ""]);
  //       }
  //     });
  //   } catch (error) {
  //     // Ignore Case;
  //   } finally {
  //     setIsLoading(false);
  //   }
  // }

  return (
    <div id="main-wrapper">
      <div className="container-fluid">
        <div className="d-flex align-items-center justify-content-center" style={{ height: "100vh" }}>
          <Card style={{ minWidth: "350px", width: "60%" }}>
            <Card.Body>
              <Row>
                <Col md={7}>
                  <div>
                    <div className="text-wrap text-base fw-semibold">{state?.ITEM_NM}</div>
                    <div className="text-sm text-primary">{state?.CAT_NM}</div>
                  </div>
                  <hr className="text-primary" />

                  <Row className="mt-4">
                    <Col md={7}>
                      <p
                        style={{ textAlign: "justify" }}
                        dangerouslySetInnerHTML={{
                          __html: state?.DESCRIPTION,
                        }}
                      ></p>
                    </Col>
                    <Col md={5}>
                      <img
                        src={
                          state?.IMG ? state?.IMG : "/assets/images/02.png"
                        }
                        alt="CRMS"
                        width={"100%"}
                      />
                    </Col>
                  </Row>
                </Col>

                <Col md={5}>
                  <div className="align-self-center ">
                    <a
                      href="../main/index.html"
                      className="text-nowrap logo-img d-block mb-3 text-center"
                    >
                      <img
                        src="/assets/images/logo3.png"
                        width={220}
                        alt="Logo"
                      />
                    </a>
                    <h6
                      className="mb-4 text-center"
                      style={{
                        paddingBottom: "20px",
                      }}
                    >
                      Fill in your details here for inquiry
                    </h6>
                    <Formik
                      initialValues={{
                        personName: "",
                        mobileNo: "",
                        email: "",
                        bankName: "",
                      }}
                      validationSchema={validationSchema}
                      onSubmit={handleSubmit}
                    >
                      {({ handleChange, handleBlur, values }) => (
                        <Form>
                          <div className="mb-3">
                            <TextField
                              label="Contact Person"
                              name="personName"
                              type="text"
                              IconProp={BiUser}
                              value={values.personName}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              maxLength={25}
                            />
                            <ErrorMessage
                              name="personName"
                              component="div"
                              className="error-msg"
                            />
                          </div>
                          <div className="mb-3">
                            <TextField
                              label="Mobile Number"
                              name="mobileNo"
                              type="text"
                              IconProp={BiPhone}
                              value={values.mobileNo}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              maxLength={10}
                              onKeyPress={(event) => {
                                if (!/[0-9]/.test(event.key)) {
                                  event.preventDefault();
                                }
                              }}
                            />
                            <ErrorMessage
                              name="mobileNo"
                              component="div"
                              className="error-msg"
                            />
                          </div>
                          <div className="mb-3">
                            <TextField
                              label="Email (Optional)"
                              name="email"
                              type="text"
                              IconProp={BiEnvelope}
                              value={values.email}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            <ErrorMessage
                              name="email"
                              component="div"
                              className="error-msg"
                            />
                          </div>
                          <div className="mb-4">
                            <TextField
                              label="Bank Name (Optional)"
                              name="bankName"
                              type="text"
                              IconProp={BiSolidBank}
                              value={values.bankName}
                              onChange={handleChange}
                              onBlur={handleBlur}
                            />
                            <ErrorMessage
                              name="bankName"
                              component="div"
                              className="error-msg"
                            />
                          </div>

                          <Row className="mt-3">
                            <Col md={6}>
                              <div className="d-flex">
                                <div className="form-control form-control-sm p-1 capcha-input"
                                  style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0, backgroundColor: "#f0f0f0", height: 35 }}>
                                  <img src={captchaDtl?.captchaImage ? "data:image/jpeg;base64," + captchaDtl?.captchaImage : ""} alt="captcha" className="w-100 h-100" />
                                </div>
                                <Button variant='primary' disabled={isCaptchaLoader} type="button" className="btn-sm" style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                                  onClick={() => {
                                    getRegularCaptcha();
                                  }}>
                                  {isCaptchaLoader ? <BiLoader className="bx-spin text-white text-lg" /> : <BiRefresh className='text-white text-lg' />}
                                </Button>
                              </div>
                            </Col>
                            <Col md={6} className="mt-md-0 mt-3">
                              <TextField
                                label="Captcha"
                                name="enterCaptcha"
                                id="enterCaptcha"
                                size="small"
                                tabIndex={2}
                                maxLength={8}
                                required
                                disabled={isLoading}
                                value={values.enterCaptcha}
                                onChange={handleChange}
                                onBlur={handleBlur}
                              />
                              <ErrorMessage name="enterCaptcha" className='error-msg' component="div" />
                            </Col>
                          </Row>

                          <div className="form-group my-4 text-center">
                            <Button
                              type="submit"
                              variant="primary"
                              className="w-100"
                            >
                              {!isLoading ? (
                                "Apply"
                              ) : (
                                <>
                                  <BiLoader className="bx-spin text-white text-lg me-2" />{" "}
                                  Loading...
                                </>
                              )}
                            </Button>
                          </div>

                          <span className="text-link">
                            <a
                              className="fw-normal d-flex justify-content-center"
                              onClick={() => navigate("/product-page")}
                              role="button"
                            >
                              <BiLeftArrowAlt className="text-lg me-1" />
                              Go Back
                            </a>
                          </span>

                          <div className="text-center px-4 mt-3 fw-light">
                            <p className="text-xs text-center fs-6 text-slate-700">
                              Developed by
                              <NavLink
                                className="fw-medium ms-2 text-uppercase text-link "
                                to="https://soft-techsolutions.com/"
                                target="_blank"
                                rel="prefetch"
                              >
                                Soft-tech Solutions &nbsp;
                              </NavLink>
                              | Copyright © {new Date().getFullYear()}
                            </p>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default InquiryForm;
